import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { FolderType } from '../constants';

export const useLogCompleteMoveGoods = (folderType: FolderType) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({
      name: 'COMPLETE_MOVE_GOODS',
      channel: ['amplitude', 'ablylog'],
      analytics: { FOLDER_TYPE: folderType },
    });
  }, [logAnalyticsEvent, folderType]);
};
